import {charcoal} from '../sass/base/_exports.sass';

export const InformationFillIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 29.3334C8.63599 29.3334 2.66666 23.364 2.66666 16C2.66666 8.63602 8.63599 2.66669 16 2.66669C23.364 2.66669 29.3333 8.63602 29.3333 16C29.3333 23.364 23.364 29.3334 16 29.3334ZM14.6667 14.6667V22.6667H17.3333V14.6667H14.6667ZM14.6667 9.33335V12H17.3333V9.33335H14.6667Z"
        fill={color}
      />
    </svg>
  );
};
